import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { CheckCircle2, AlertTriangle } from 'lucide-react';
import { ppvVerify } from '../api/services';

const PPVSuccess = () => {
  const [params] = useSearchParams();
  const nav = useNavigate();
  const [status, setStatus] = useState('verifying');
  const ranRef = useRef(false);

  useEffect(() => {
    if (ranRef.current) return; ranRef.current = true;
    const showId = params.get('show');
    const orderId = params.get('orderId') || params.get('order_id') || '';
    if (!showId) { nav('/', { replace: true }); return; }
    let attempts = 0;
    let timer;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await ppvVerify(showId, orderId);
        if (res.status === 'granted') {
          setStatus('success');
          setTimeout(() => nav('/originals', { replace: true }), 2200);
          return;
        }
      } catch {}
      if (attempts < 8) timer = setTimeout(poll, 1500); else setStatus('pending');
    };
    poll();
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center px-6">
      <div className="max-w-md w-full text-center p-10 rounded-2xl bg-white/5 border border-white/10 backdrop-blur">
        {status === 'verifying' && (
          <>
            <div className="mx-auto w-14 h-14 rounded-full border-4 border-white/10 border-t-[#E50914] animate-spin" />
            <h2 className="mt-5 text-2xl font-semibold">Confirming your purchase…</h2>
          </>
        )}
        {status === 'success' && (
          <>
            <CheckCircle2 className="mx-auto text-emerald-400" size={56} />
            <h2 className="mt-4 text-2xl font-semibold">You're in.</h2>
            <p className="text-white/60 mt-2">Enjoy the show — redirecting…</p>
          </>
        )}
        {status === 'pending' && (
          <>
            <AlertTriangle className="mx-auto text-amber-400" size={56} />
            <h2 className="mt-4 text-2xl font-semibold">Still processing</h2>
            <p className="text-white/60 mt-2">Square is finalizing your payment. Refresh in a few seconds.</p>
            <button onClick={() => nav('/')} className="mt-6 px-5 py-2.5 rounded-lg bg-white text-black font-semibold">Back home</button>
          </>
        )}
      </div>
    </div>
  );
};

export default PPVSuccess;
